import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const visibilityTutorial = (id, buttonText) => [
  {
    element: '.vis_shortcut',
    intro:
      'Chyba już tu byłeś. :) Tak, w pierwszym kroku tutorialu pokazaliśmy Ci skrót, który został utworzony właśnie tutaj.'
  },
  {
    element: '.vis_layers',
    intro: `Te przełączniki służą do ustawiania widoczności warstw wektorowych na mapie. Pamiętaj jednak że im więcej elementów na mapie tym gorsza wydajność. Nie zaleca się uruchamiać wszystkich warstw jednocześnie. Do wyrenderowania wszystkich warstw w przypadku intensywnych zjawisk atmosferycznych potrzebna jest solidna pamięć RAM. W przypadku niedostępności danych dla poszczególnych dat, warstwy nie będą się wyświetlać mimo włączonej widoczności. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
